export const PROJECT_POSITIONS = {
	Primary: 'Primary',
	Seconday: 'Secondary',
};
